// B2-INT Level Aggregator - B2 Interview Training
// Tüm B2-INT ünite içeriklerini birleştirir

import { B2INT_UNIT_1 } from './kariyerContentsB2INTUnit1';
import { B2INT_UNIT_2 } from './kariyerContentsB2INTUnit2';
import { B2INT_UNIT_3 } from './kariyerContentsB2INTUnit3';

export const B2INT_LEVEL = {
  ...B2INT_UNIT_1,  // Behavioral Sorular (STAR Metodu)
  ...B2INT_UNIT_2,  // Situational Sorular
  ...B2INT_UNIT_3,  // Grup Mülakat ve Assessment
};

export default B2INT_LEVEL;
